export function ContactIcon({ icon: Icon }) {
  return (
    <div className="w-14 h-14 bg-blue-900 rounded-full flex items-center justify-center text-white flex-shrink-0">
      <Icon className="w-6 h-6" />
    </div>
  );
}
